import { createFileRoute } from "@tanstack/react-router";

import { loadMe } from "../features/auth/session";
import { PublicLayout } from "../features/marketing/PublicLayout";
import { LegalPage } from "../features/marketing/legal/LegalPage";
import { TERMS } from "../features/marketing/legal/terms";

export const Route = createFileRoute("/terms")({
  staticData: { publicShell: true },
  loader: ({ context }) => loadMe(context.queryClient),
  component: TermsPage,
});

function TermsPage() {
  const me = Route.useLoaderData();
  return (
    <PublicLayout signedIn={me !== null}>
      <LegalPage documents={TERMS} />
    </PublicLayout>
  );
}
